import React, { useEffect } from "react"
import { useState } from "react";
import background1 from './background.jpg'
import Resume from './resume.pdf'
export default function Home(){
    const [h1text, setH1Text] = useState("Sanskar Garodia");

// Get the URL of the PDF from Firebase Storage


    useEffect(()=>{
        const handleFontOfName = ()=>{    
            if(window.scrollY > 30 )  {
                setH1Text("Sanskar Garodia");
            }
          if(window.scrollY > 50 )  {
                setH1Text("SAnskar Garodia");
            }
            if(window.scrollY > 70 )  {setH1Text("SANskar Garodia");}
            if(window.scrollY > 90 )  {setH1Text("SANSkar Garodia");}
            if(window.scrollY > 110 )  {setH1Text("SANSKar Garodia");}
            if(window.scrollY > 130 )  {setH1Text("SANSKAr Garodia");}
            if(window.scrollY > 150 )  {setH1Text("SANSKAR Garodia");}
            if(window.scrollY > 170 )  {setH1Text("SANSKAR GArodia");}
            if(window.scrollY > 190 )  {setH1Text("SANSKAR GARodia");}
            if(window.scrollY > 210 )  {setH1Text("SANSKAR GAROdia");}
            if(window.scrollY > 230 )  {setH1Text("SANSKAR GARODia");}
            if(window.scrollY > 250 )  {setH1Text("SANSKAR GARODIa");}
            if(window.scrollY > 270 )  {setH1Text("SANSKAR GARODIA");}
                
        };
        window.addEventListener('scroll', handleFontOfName);
    },[]);
    
    

    return(
        <div style={{backgroundImage:`url(${background1})`}}>
            <div className="1" style={{height:"100vh",alignItems:"center",display:"flex",justifyContent:"center",backgroundColor:"#1D3353",flexDirection:"column",alignSelf:"stretch",width:"100%",opacity:"0.5"}}>
                
                <h2 style={{fontSize:"2vw",margin:"0 0 0 0",color:"lightgrey"}}>Hey, I am</h2>
                <h1 style={{fontSize:"6vw",fontStyle:"bold",margin:"0 0 0 0",color:"lightgrey",fontFamily:"Playfair"}}>{h1text}</h1>
                <h2 style={{fontSize:"2vw",margin:"0 0 0 0",color:"lightgrey",fontFamily:"Playfair"}}>I am a Software Engineer</h2>   
                <a
                href={Resume}
                download="Resume"
                target="_blank"
                rel="noopener noreferrer"
                >
                <button style={{backgroundColor:"white",marginTop:'50px', padding:'10px 50px 10px 50px',borderRadius:"14px 14px 14px 14px"}}>Download Resume</button>
                    
                </a>
                
            </div>
        </div>
        )
}